import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  stepperContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(8),
  },

  logo: {
    fontSize: "1.5rem",
    fontWeight: 900,
    letterSpacing: "-0.05em",
    color: "#06e89f",
  },

  stepsRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
  },

  stepDone: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    opacity: 0.6,
  },

  stepActive: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },

  stepInactive: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    opacity: 0.4,
  },

  circleDone: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    backgroundColor: "#006c48",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 700,
    color: "#ffffff",
  },

  circleActive: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    backgroundColor: "#06e89f",
    color: "#000c61",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 700,
    boxShadow: "0 0 0 0 rgba(6, 232, 159, 0.4)",
    animation: "$pulse 2s infinite",
  },

  circleInactive: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    border: "2px solid rgba(255, 255, 255, 0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 700,
    color: theme.palette.text.paymentBack,
  },

  stepLine: {
    height: 1,
    width: 48,
    backgroundColor: theme.palette.text.step,
  },

  stepText: {
    fontSize: "0.875rem",
    textTransform: "uppercase",
    letterSpacing: "0.15em",
    color: theme.palette.text.paymentTitle,
  },

  "@keyframes pulse": {
    "0%": {
      boxShadow: "0 0 0 0 rgba(6, 232, 159, 0.4)",
    },
    "70%": {
      boxShadow: "0 0 0 10px rgba(6, 232, 159, 0)",
    },
    "100%": {
      boxShadow: "0 0 0 0 rgba(6, 232, 159, 0)",
    },
  },
}));

export { useStyles };
